export default "/build/images/028-1-300x300.png?79718ff7c526a98a95dcfd1644022cfc";